"use strict";

/*global  jQuery*/

// 共通部品読み込み処理
function headerWrite(targetID, rootDir) {
  var target = document.getElementById(targetID);
  $.ajax({
    url: rootDir + "include/header.html", // ディレクトリー変更
    cache: false,
    async: false,
    dataType: 'html',
    success: function (html) {
      html = html.replace(/\{\$root\}/g, rootDir);
      target.innerHTML = html;
    }
  });
}
function menuSide(contentsID, targetID, rootDir) {
  var target = document.getElementById(targetID);
  var contentsPath = '';
  switch (contentsID) {
    case 'corporate': //企業情報
      contentsPath = 'include/menu_corporate.html'; 
      break;
    case 'recruit': //採用情報
      contentsPath = 'include/menu_recruit.html'; 
      break;
    case 'public': //共通
      contentsPath = 'include/menu_public.html';
      break;
    case 'kojin': //個人
      contentsPath = 'include/menu_kojin.html';
      break;
    case 'service_kojin': //個人サービス
      contentsPath = 'include/menu_service_kojin.html';
      break;
    case 'hojin': //法人
      contentsPath = 'include/menu_hojin.html';
      break;
    case 'service_hojin': //法人サービス
      contentsPath = 'include/menu_service_hojin.html';
      break;
    case 'service': //サービス
        contentsPath = 'include/menu_service.html';
        break;
    case 'topics': //トピックス
        contentsPath = 'include/menu_topics.html';
        break;
    case 'kiyaku': //規約
      contentsPath = 'include/menu_kiyaku.html';
      break;
    case 'yushi': //融資関連情報
      contentsPath = 'include/menu_yushi.html';
      break;
    case 'intbank':
      contentsPath = 'include/menu_intbank.html';
      break;
    case 'webfb': //WEB-FB
      contentsPath = 'include/menu_webfb.html';
      break;
    case 'densai': //電子記録債権
      contentsPath = 'include/menu_densai.html';
      break;
    case 'banner': //バナー共通
      contentsPath = 'include/menu_banner.html';
      break;
    case 'banner2': //バナーTOP・個人用
      contentsPath = 'include/menu_banner2.html';
      break;
    case 'banner2_hojin': //バナー法人用
      contentsPath = 'include/menu_banner2_hojin.html';
      break;
    case 'footer':
      contentsPath = 'include/menu_footer.html';
      break;
    case 'login':
      contentsPath = 'include/menu_login.html';
      break;
    case 'sp':
      contentsPath = 'include/menu_sp.html';
      break;
    default:
      console.log('out of case');
      return 0;
  }
  $.ajax({
    url: rootDir + contentsPath, // ディレクトリー変更
    cache: false,
    async: true,
    dataType: 'html'
  }).then(
    function (html) {
      html = html.replace(/\{\$root\}/g, rootDir);
      target.innerHTML = html;
    })
    .catch(
      function (html) {
        target.innerHTML = '<p>Read Error..</p>';
      })
    .then(
      function (html) {
        setCurrentSide();
      }
    );
}

function infoList2(contentsID, targetID, rootDir) {
  var target = document.getElementById(targetID);
  var contentsPath = '';
  switch (contentsID) {
    case 'news':
      contentsPath = 'include/news.html';
      break;
    case 'important':
      contentsPath = 'include/news_important.html';
      break;
    default:
      console.log('out of');
      return 0;
  }
  $.ajax({
    url: rootDir + contentsPath, // ディレクトリー変更
    cache: false,
    async: true,
    dataType: 'html'
  }).then(
    function (html) {
      html = html.replace(/\{\$root\}/g, rootDir);
      target.innerHTML = html;
    })
    .catch(
      function (html) {
        target.innerHTML = '<p>Read Error..</p>';
      })
    .then(
      function (html) {
        addLabel_new(targetID);
      }
    );
}
function infoList(contentsID, targetID, rootDir) {
  var target = document.getElementById(targetID);
  var contentsPath = '';
  switch (contentsID) {
    case 'news':
      contentsPath = 'include/news.html';
      break;
    case 'important':
      contentsPath = 'include/news_important.html';
      break;
    default:
      console.log('out of');
      return 0;
  }
  $.ajax({
    url: rootDir + contentsPath, // ディレクトリー変更
    cache: false,
    async: true,
    dataType: 'html'
  }).then(
    function (html) {
      html = html.replace(/\{\$root\}/g, rootDir);
      target.innerHTML = html;
    })
    .catch(
      function (html) {
        target.innerHTML = '<p>Read Error..</p>';
      })
    .then(
      function (html) {
        addLabel_new(targetID);
      }
    );
}

function readImportant(contentsID, targetID, rootDir) {
  var target = document.getElementById(targetID);
  var contentsPath = '';
  switch (contentsID) {
    case 'news':
      contentsPath = 'include/news.html';
      break;
    case 'important':
      contentsPath = 'inform/00inform.html';
      break;
    default:
      console.log('out of');
      return 0;
  }
  $.ajax({
    url: rootDir + contentsPath, // ディレクトリー変更
    cache: false,
    async: true,
    dataType: 'html'
  }).then(
    function (html) {
      var contents = $(html).find('#js_news01').html();
      // html = html.replace(/\{\$root\}/g, rootDir);
      contents = contents.replace(/\.\.\//g, rootDir);
      target.innerHTML = contents;
    })
    .catch(
      function (html) {
        target.innerHTML = '<p>Read Error..</p>';
      })
    .then(
      function (html) {
        addLabel_new(targetID);
      }
    );
}

function readTopics(contentsID, targetID, rootDir) {
  var target = document.getElementById(targetID);
  var contentsPath = '';
  switch (contentsID) {
    case 'news':
      contentsPath = 'include/news.html';
      break;
    case 'topics':
      contentsPath = 'topics/index.html';
      break;
    default:
      console.log('out of');
      return 0;
  }
  $.ajax({
    url: rootDir + contentsPath, // ディレクトリー変更
    cache: false,
    async: true,
    dataType: 'html'
  }).then(
    function (html) {
      var contents = $(html).find('#js_topics').html();
      // html = html.replace(/\{\$root\}/g, rootDir);
      contents = contents.replace(/\.\.\//g, rootDir);
      target.innerHTML = contents;
    })
    .catch(
      function (html) {
        target.innerHTML = '<p>Read Error..</p>';
      })
    .then(
      function (html) {
        addLabel_new(targetID);
      }
    );
}

function readYushi(contentsID, targetID, rootDir) {
  var target = document.getElementById(targetID);
  var contentsPath = '';
  switch (contentsID) {
    case 'yushi':
      contentsPath = 'hojin/yushi_list.html';
      break;
    default:
      console.log('out of');
      return 0;
  }
  $.ajax({
    url: rootDir + contentsPath, // ディレクトリー変更
    cache: false,
    async: true,
    dataType: 'html'
  }).then(
    function (html) {
      var contents = $(html).find('#js_news01').html();
      contents = contents.replace(/\.\.\//g, rootDir);
      target.innerHTML = contents;
    })
    .catch(
      function (html) {
        target.innerHTML = '<p>Read Error..</p>';
      })
    .then(
      function (html) {
        addLabel_new(targetID);
      }
    );
}

function readIB(contentsID, targetID, rootDir) {
  var target = document.getElementById(targetID);
  var contentsPath = '';
  var readID = '';
  switch (contentsID) {
    case 'ib_important':
      contentsPath = 'intbank/inform_list.html';
      readID = "#js_importantIbnk";
      break;
    case 'ib_info':
      contentsPath = 'intbank/inform_list.html';
      readID = "#js_newsIbnk";
      break;
    default:
      console.log('out of');
      return 0;
  }
  $.ajax({
    url: rootDir + contentsPath, // ディレクトリー変更
    cache: false,
    async: true,
    dataType: 'html'
  }).then(
    function (html) {
      var contents = $(html).find(readID).html();
      contents = contents.replace(/\.\.\//g, rootDir);
      target.innerHTML = contents;
    })
    .catch(
      function (html) {
        target.innerHTML = '<p>Read Error..</p>';
      })
    .then(
      function (html) {
        addLabel_new(targetID);
      }
    );
}

function readWEBFB(contentsID, targetID, rootDir) {
  var target = document.getElementById(targetID);
  var contentsPath = '';
  var readID = '';
  switch (contentsID) {
    case 'webfb_info01':
      contentsPath = 'web-fb/inform_list.html';
      readID = "#js_news01";
      break;
    case 'webfb_info02':
      contentsPath = 'web-fb/inform_list.html';
      readID = "#js_news02";
      break;
    case 'webfb_info03':
      contentsPath = 'web-fb/inform_list.html';
      readID = "#js_news03";
      break;
    default:
      console.log('out of');
      return 0;
  }
  $.ajax({
    url: rootDir + contentsPath, // ディレクトリー変更
    cache: false,
    async: true,
    dataType: 'html'
  }).then(
    function (html) {
      var contents = $(html).find(readID).html();
      contents = contents.replace(/\.\.\//g, rootDir);
      target.innerHTML = contents;
    })
    .catch(
      function (html) {
        target.innerHTML = '<p>Read Error..</p>';
      })
    .then(
      function (html) {
        addLabel_new(targetID);
      }
    );
}

function readDENSAI(contentsID, targetID, rootDir) {
  var target = document.getElementById(targetID);
  var contentsPath = '';
  var readID = '';
  switch (contentsID) {
    case 'densai_info01':
      contentsPath = 'densai/inform_list.html';
      readID = "#js_newsImportant";
      break;
    case 'densai_info02':
      contentsPath = 'densai/inform_list.html';
      readID = "#js_newsDensai";
      break;
    default:
      console.log('out of');
      return 0;
  }
  $.ajax({
    url: rootDir + contentsPath, // ディレクトリー変更
    cache: false,
    async: true,
    dataType: 'html'
  }).then(
    function (html) {
      var contents = $(html).find(readID).html();
      contents = contents.replace(/\.\.\//g, rootDir);
      target.innerHTML = contents;
    })
    .catch(
      function (html) {
        target.innerHTML = '<p>Read Error..</p>';
      })
    .then(
      function (html) {
        addLabel_new(targetID);
      }
    );
}


// DOM読み込み完了
// document.addEventListener('DOMContentLoaded', function (e) {
//   console.log('DOM Content Loaded.');

//   var menuParent = document.getElementsByClassName('menu-item-has-children');
//   for (var i = 0; i < menuParent.length; i++) {
//     menuParent[i].insertAdjacentHTML('afterbegin', '<div class="toggle-submenu close"></div>');
//   }

//   // var spmenubtn = document.querySelectorAll('.toggle-submenu');
//   var spmenubtn = document.getElementsByClassName('toggle-submenu');
//   for (let i = 0; i < spmenubtn.length; i++) {
//     // fuga[i]で現在の要素を指定
//     spmenubtn[i].addEventListener('click', function () {
//       spmenubtn[i].classList.toggle('close');
//       spmenubtn[i].classList.toggle('open');
//     }, false);
//   }

// }, false);

// 完全に読み込み完了
window.addEventListener('load', function () {
  // console.log('Page Loaded.');
});

// スマホメニュー開閉処理
$(document).on('click', '.bl_navSP_btnMenu', function () {
  $('.bl_menuSP,.bl_spBg').toggleClass('open');
});
$(document).on('click', '.bl_navSP_btnLogin', function () {
  $('.bl_loginSP,.bl_spBg').toggleClass('open');
});
$(document).on('click', '.bl_spBg,.el_btnMenu_close', function () {
  $('.bl_menuSP,.bl_loginSP,.bl_spBg').removeClass('open');
});

$(document).on('click', '.toggle-submenu', function () {
  $(this).toggleClass('open');
  $(this).toggleClass('close');
});

// ページ内スムーズスクロール 
$(document).on('click', 'a.js_linkScroll,a[data-js_scroll]', function (event) {
  // 移動先を0px調整する。0を30にすると30px下にずらすことができる。
  var adjust = 0;
  // スクロールの速度（ミリ秒）
  var speed = 400;
  // アンカーの値取得 リンク先（href）を取得して、hrefという変数に代入
  var href = $(this).attr("href");
  // 移動先を取得 リンク先(href）のidがある要素を探して、targetに代入
  var target = $(href == "#" || href == "" ? 'html' : href);
  // 移動先を調整 idの要素の位置をoffset()で取得して、positionに代入
  var position = target.offset().top + adjust;
  // スムーススクロール linear（等速） or swing（変速）
  $('body,html').animate({ scrollTop: position }, speed, 'swing');
  return false;
});

// ページ内スムーズスクロール 
$(document).on('click', '.btn-pagetop', function (event) {
  $('body, html').animate({ scrollTop: 0 }, 500);
  return false;
});

// スライドショー
$('.slide_top').slick({
  arrows: true,
  dots: true,
  infinite: true,
  speed: 500,
  fade: true,
  cssEase: 'linear',
  autoplay: true,
  autoplaySpeed: 3000,
});
$(document).ready(function(){
  setTimeout(function() {
    $('.slide_top .slick-next, .slide_top .slick-prev').addClass('is_show');
  }, 3100); 
});

// スライドショー
$('.slide_campaign').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows: true,
  dots: true,
  infinite: true,
  speed: 500,
  cssEase: 'linear',
  autoplay: true,
  autoplaySpeed: 3000,
  responsive: [
    {
      breakpoint: 1140,
      settings: {
        arrows: false,
        centerMode: true,
        centerPadding: '40px',
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        arrows: false,
        centerMode: true,
        centerPadding: '40px',
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
  ]
});
$(".slide_campaign .slide").heightLine();

// お知らせ一覧に日付を判断し、NEWを追加する。
function addLabel_new(targetID) {
  var wkTarget = '#' + targetID + ' .bl_newsList_date';
  // console.log(wkTarget);
  $(wkTarget).each(function (index, target) {
    // var limitDay = 7; //7日後まではNEWを追加する
    var limitDay = 30; //30日後まではNEWを追加する
    var wkDate = $(this).attr("data-post_date");
    var nowDate = new Date();

    nowDate = new Date(nowDate.getFullYear(), nowDate.getMonth(), nowDate.getDate())

    if (wkDate) {
      wkDate = new Date(wkDate);
      wkDate.setDate(wkDate.getDate() + limitDay);
    } else {
      wkDate = 0;
    }

    if (wkDate.getTime() >= nowDate.getTime()) {
      $(this).next().append('<li class="bl_labelList_item label_new">NEW</li>');
    }

  });
}


//  旧HTMLより移植
// インターネットバンキング
/*ログインURL*/
function versioncheck(n) {
  /*ログイン*/
  if (n == 1) {
    window.open('https://www11.ib.shinkin-ib.jp/webbk/login/b-prelogin.do?bankcode=MTYzMw==', 'kib');
  }
  /*利用申込予��?��座あり*/
  else if (n == 3) {
    window.open('https://www11.ib.shinkin-ib.jp/webbk/app/preb-initalAction.do?bankcode=MTYzMw==&bankprintspt=1&cusKnd=1', 'kib');
  }
  /*利用申込予��?��座な��?*/
  else if (n == 4) {
    window.open('https://www11.ib.shinkin-ib.jp/webbk/app/preb-initalAction.do?bankcode=MTYzMw==&bankprintspt=1&cusKnd=2', 'kib');
  }

}

// 電子記録債権表示
function WO(){
	window.open('https://www02.shinkin-ib.jp/wm/wmelin/wmelin000.do?userId_cd=23&bank_cd=MTYzMw==','densai','toolbar=1,location=1,scrollbars=1,status=1,width=800,height=600,resizable=1');
}

// サイドメニューカレント表示
function setCurrentSide(){
  // $('.bl_sideMenu .current').removeClass('current');
  
  // $('.bl_sideMenu .menu_itemParent a,.bl_sideMenu__intbank .menu_itemParent a,.bl_sideMenu__webfb .menu_itemParent a,.bl_sideMenu__densai .menu_itemParent a').filter(function(){return $(this).prop('href')==location.href;}).parent().addClass('current');
  $('.bl_sideMenu .menu_itemParent > a,.bl_sideMenu__intbank .menu_itemParent > a,.bl_sideMenu__webfb .menu_itemParent > a,.bl_sideMenu__densai .menu_itemParent > a').each(function(){
    var wkTarget = $(this).prop('href');
    var wkLocation =location.href;
    wkTarget = wkTarget.replace(/#.*$/,"");
    wkLocation = wkLocation.replace(/#.*$/,"");
    wkTarget = wkTarget.replace(/index.html.*$/,"");
    wkLocation = wkLocation.replace(/index.html.*$/,"");
    // if(location.href === wkTarget){
    if(wkLocation === wkTarget){
      // console.log(wkTarget);
      $(this).parent().addClass('current');
      $(this).parents('.menu_itemParent').children('.toggle-submenu').addClass('open');
      $(this).parents('.menu_itemParent').children('.toggle-submenu').removeClass('close');
    }
  });

  // $('.bl_sideMenu .menu_itemChild a').filter(function(){return $(this).prop('href')==location.href;}).parent().addClass('current');
  $('.bl_sideMenu .menu_itemChild > a,.bl_sideMenu__intbank .menu_itemChild > a,.bl_sideMenu__webfb .menu_itemChild > a,.bl_sideMenu__densai .menu_itemChild > a').each(function(){
    var wkTarget = $(this).prop('href');
    var wkLocation =location.href;
    wkTarget = wkTarget.replace(/#.*$/,"");
    wkLocation = wkLocation.replace(/#.*$/,"");
    wkTarget = wkTarget.replace(/index.html.*$/,"");
    wkLocation = wkLocation.replace(/index.html.*$/,"");
    // if(location.href === wkTarget){
    // if(location.href.match(wkTarget)){
    if(wkLocation === wkTarget){
      // console.log(wkTarget);
      $(this).parent().addClass('current');
      $(this).parents('.menu_itemParent').addClass('current');
      $(this).parents('.menu_itemParent').children('.toggle-submenu').addClass('open');
      $(this).parents('.menu_itemParent').children('.toggle-submenu').removeClass('close');
    }
  });

  $('.bl_sideMenuKiyaku .menu_item > a').each(function(){
    var wkTarget = $(this).prop('href');
    var wkLocation =location.href;
    wkTarget = wkTarget.replace(/#.*$/,"");
    wkLocation = wkLocation.replace(/#.*$/,"");
    wkTarget = wkTarget.replace(/index.html.*$/,"");
    wkLocation = wkLocation.replace(/index.html.*$/,"");
    // if(location.href === wkTarget){
    // if(location.href.match(wkTarget)){
    if(wkLocation === wkTarget){
      // console.log(wkTarget);
      $(this).parent().addClass('current');
    }
  });
}
  









//----------------------------------------------------------
// カレントページへのリンクを無効化
// 引数：付加するクラス名（オプション）
// 返値：無効化したリンクの数
//----------------------------------------------------------
function removeCurrentLink(addClassName){

  var count = 0;  // 無効化した数

  // 全アンカーの取得
  var elmsAnchor = document.getElementsByTagName("a");

  for(var i=0; i<elmsAnchor.length; i++){
    var elmAnchor = elmsAnchor.item(i);

    // 自分を指すリンクであれば
    if(elmAnchor.href == parent.location.href){
      // elmAnchor.removeAttribute("href");    // 属性を削除
      // elmAnchor.style.backgroundColor = '#999999';
      // elmAnchor.style.color = 'white';
      // elmAnchor.style.borderLeft = "solid 0px #999999"; 
      // elmAnchor.style.textDecoration = 'none'; 

      // 引数でクラス名が指定されていれば
      if(addClassName){
        elmAnchor.className = addClassName; // クラス名を付加
      }
      count++;
    }
  }
  return count;
}


//----------------------------------------------------------
// クラス名を追加
// 引数：対象ノード, クラス名
// 返値：0 = 追加した; 1 = すでにある
//----------------------------------------------------------
function addClassName(argNode, argClassName){
  if(isClassName(argNode, argClassName) != "-1"){
    return 1;  // すでにある場合は無視
  }
  // 空白とともに追加
  argNode.className += " " + argClassName;
  return 0;
}


//----------------------------------------------------------
// クラス名が含まれるか判別
// 引数：対象ノード, クラス名
// 返値：-1 = ない; 0以上 = 見つかった場所(一番左を0とする)
//----------------------------------------------------------
function isClassName(argNode, argClassName){
  if(argNode.className != ""){
    var aryClassName = String(argNode.className).split(" ");
    for(i=0; i<aryClassName.length; i++){
      if(aryClassName[i] == argClassName){ return i; }
    }
  }
  return -1;  // 見つからなければ -1 を返す
}


//----------------------------------------------------------
// onload で実行する関数
//----------------------------------------------------------
function loadEvent(){
  // カレントページへのリンクを無効化
  // removeCurrentLink("is_active"); // クラス名 "is_active"を付加
  // setCurrentSide();
}

window.onload = loadEvent;